import {SerializedStyles} from '@emotion/react';
import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import checkIcon from 'src/assets/icons/checkIcon.svg';
import {GetStylesFunction} from 'src/js/common/types';

interface OwnProps {
  inputCss?: SerializedStyles;
  style?: React.CSSProperties;
}

type Props = OwnProps;

export const DlMuiCheckIcon: React.FC<Props> = (props) => {
  const {inputCss, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {inputCss}});

  return <SvgIcon css={styles.checkIcon} component={checkIcon} inheritViewBox {...restProps} />;
};

DlMuiCheckIcon.displayName = 'DlMuiCheckIcon';

const getStyles: GetStylesFunction = (options) => ({
  checkIcon: css(
    {
      width: '18px',
      height: '22px',
    },
    options?.params?.inputCss
  ),
});
